module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('div', {
    staticClass: "imagefp"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page i. ",
      "epub:type": "pagebreak",
      "id": "page_i",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "imagefc",
    attrs: {
      "alt": "Cover: The web of meaning : integrating science and traditional wisdom to find our place in the universe by Jeremy Lent.",
      "role": "doc-cover",
      "src": "images/cover.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c1496e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cover.vue
// module id = 54
// module chunks = 0